<sms-dialog
  [title]="'Email Report'"
  [subtitle]="data.reportName"
  [size]="'md'"
  (close)="cancel()">

  <form body [formGroup]="form" (ngSubmit)="send()" class="erd-form">
    <div class="erd-row">
      <label class="form-label">To <span class="req">*</span></label>
      <input type="text"
             class="form-control"
             formControlName="to"
             placeholder="email@school.in, another@school.in" />
      <small class="erd-help">Comma- or space-separated.</small>
      <small class="erd-error" *ngIf="toError">{{ toError }}</small>
    </div>

    <div class="erd-row">
      <label class="form-label">CC</label>
      <input type="text"
             class="form-control"
             formControlName="cc"
             placeholder="(optional)" />
      <small class="erd-error" *ngIf="ccError">{{ ccError }}</small>
    </div>

    <div class="erd-row">
      <label class="form-label">Subject <span class="req">*</span></label>
      <input type="text"
             class="form-control"
             formControlName="subject"
             placeholder="Enter email subject" />
    </div>

    <div class="erd-row">
      <label class="form-label">Message</label>
      <textarea class="form-control"
                rows="4"
                formControlName="body"
                placeholder="Enter the email message"></textarea>
    </div>

    <div class="erd-row">
      <label class="form-label">Attachment Format</label>
      <div class="erd-format-list">
        <label *ngFor="let f of formats" class="erd-format-option">
          <input type="radio" formControlName="format" [value]="f.value" />
          <span>{{ f.label }}</span>
        </label>
      </div>
    </div>
  </form>

  <ng-container footer>
    <button type="button" class="secondary-btn" (click)="cancel()">Cancel</button>
    <button type="button" class="primary-button" (click)="send()">Send Email</button>
  </ng-container>
</sms-dialog>
